export default "/assets/images/smoke-png.f6dce0efc6955bf6.png";